<template>
  <div class="steps">
    <div
      :class="{'steps__step--active': step === 1} "
      class="steps__step steps__step--opened"
    >
      Account
    </div>
    <div
      :class="{'steps__step--opened': step > 1, 'steps__step--active': step === 2} "
      class="steps__step"
    >
      Verification
    </div>
    <div
      :class="{'steps__step--opened': step > 2, 'steps__step--active': step === 3}"
      class="steps__step"
    >
      Location
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddStepper',

  props: {
    step: {
      type: Number,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.steps {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  &__step {
    padding: 8px 0;
    font-size: 14px;
    font-family: var(--head-font);
    text-align: center;
    border-bottom: 2px solid transparent;
    background-color: #eee;

    @media (min-width: 768px) {
      font-size: 18px;
    }

    &--active {
      color: #0e9bea;
      border-color: currentColor;
    }

    &--opened {
      background-color: transparent;
    }
  }
}

</style>